
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print/materials",
      function () {
        return require("private-next-pages/customizing/print/materials/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customizing/print/materials"])
      });
    }
  